if (typeof retaledItemComponent === 'undefined')
{   
    class RelatedItemsComponent extends HTMLElement {
        constructor() {
            super();
        }

        connectedCallback() {
           const productCarousel = this.querySelector('.products-carousel');
           this.initializeSlider(productCarousel);
        }

        initializeSlider(productCarousel = null) {
            if (productCarousel) {
                const itemArrows = productCarousel.dataset.itemArrows === 'true';
                const itemDots = productCarousel.dataset.itemDots === 'true';
                const itemRows = parseInt(productCarousel.dataset.itemRows);
                const itemToShow = Number(productCarousel.dataset.itemToShow);

                $(productCarousel).on('init', () => {
                    this.calculateCard06Padding();
                });

                if(!productCarousel.classList.contains('slick-slider')) {
                    $(productCarousel).slick({
                        dots: false,
                        arrows: true,
                        slidesToShow: itemToShow,
                        slidesToScroll: 1,
                        infinite: false,
                        rtl: false,
                        nextArrow: window.arrows.icon_next,
                        prevArrow: window.arrows.icon_prev,

                    responsive: [
                            {
                                breakpoint: 1600,
                                settings: {
                                    slidesToShow: 4,
                                    slidesToScroll: 1,
                                }
                            },
                            {
                                breakpoint: 1200,
                                settings: {
                                    slidesToShow: 4,
                                    slidesToScroll: 1,
                                }
                            },
                            {
                                breakpoint: 1025,
                                settings: {
                                    slidesToShow: 4,
                                    slidesToScroll: 1,
                                }
                            },
                            {
                                breakpoint: 945,
                                settings: {
                                    slidesToShow: 4,
                                    slidesToScroll: 1,
                                    arrows: false,
                                }
                            },
                            {
                                breakpoint: 768,
                                settings: {
                                    slidesToShow: 2,
                                    slidesToScroll: 1,
                                    arrows: false,
                                }
                            },
                            {
                                breakpoint: 399,
                                settings: {
                                    slidesToShow: 2.3,
                                    slidesToScroll: 1,
                                    arrows: false,
                                }
                            },
                            {
                                breakpoint: 321,
                                settings: {
                                    slidesToShow: 1,
                                    slidesToScroll: 1,
                                    arrows: false,
                                }
                            }
                        ]
                    });

                }
            }
        }
        
        calculateCard06Padding() {
            if (!document.body.classList.contains('product-card-layout-06')) return;

            const selectOptionsHeight = this.querySelector('.product .card-action').scrollHeight;
            this.querySelector('.slick-list').style.paddingBottom = selectOptionsHeight + 'px';
        }
    }
    
    window.addEventListener('load', () => {
        customElements.define('related-items', RelatedItemsComponent);
    })

    var retaledItemComponent = RelatedItemsComponent;
}